import {
  ChangeDetectorRef,
  Directive,
  effect,
  inject,
  input,
} from '@angular/core';
import { Password } from 'primeng/password';

@Directive({
  selector: '[appPrimengPassword]',
  standalone: true,
})
export class PrimengPasswordDirective {
  private readonly password = inject(Password);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly strongRegex = input<string>(this.defaultStrongRegex());

  public constructor() {
    this.configureAttributes();

    effect(() => this.configureStrongRegex());
  }

  private configureAttributes(): void {
    this.password.toggleMask = true;
    this.password.promptLabel = 'Zacznij wprowadzać hasło';
    this.password.mediumLabel = 'Średnie';
    this.password.strongLabel = 'Silne';
    this.password.weakLabel = 'Słabe';
  }

  private configureStrongRegex(): void {
    this.password.strongRegex = this.strongRegex();
    this.password.strongCheckRegExp = new RegExp(this.strongRegex());
    this.changeDetectorRef.detectChanges();
  }

  private defaultStrongRegex(): string {
    return '^(?=.{8,})((?=.*[^a-zA-Z\\s])(?=.*[a-z])(?=.*[A-Z])|(?=.*[^a-zA-Z0-9\\s])(?=.*\\d)(?=.*[a-zA-Z])).*$';
  }
}
